/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React, { useCallback, useEffect } from 'react'
import { Grid, Paper, Container, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import UserWizardStepper from './UserWizardStepper'
import { GetFacebookPageRequest } from '@3m5/sm_publish-frontend-api'
import {
  getIgPageInitiated,
  loadFacebookPageInitiated
} from '../../../store/dashboard/dashboard.actions'
import { useDispatch, useSelector } from 'react-redux'
import { GetInstagramPageRequest } from '@3m5/sm_publish-frontend-api'
import {
  getConnectedFacebookPage,
  getConnectedInstagramPage,
  getConnectionChanged, getFacebookRedirect, getTokenChanged, getUserPages
} from '../../../store/common/common.selectors'
import {
  getCurrentUserInitiated,
  setConnectedFacebookPage,
  setConnectedInstagramPage
} from '../../../store/common/common.actions'
import { NetworkType } from '@professocialApi/professocial-core-frontend-api'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing(3),
    padding: theme.spacing(5),
  },
}))

const UserWizard: React.FC<{setWizardCompleted: () => void}> = ({ setWizardCompleted }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const dispatchGetFacebookPage = useCallback((params: GetFacebookPageRequest) => dispatch(loadFacebookPageInitiated(params)), [dispatch])
  const dispatchGetInstagramPage = useCallback((params: GetInstagramPageRequest) => dispatch(getIgPageInitiated(params)), [dispatch])
  const dispatchSetConnectedFacebookPage = useCallback((params: string) => dispatch(setConnectedFacebookPage(params)), [dispatch])
  const dispatchSetConnectedInstagramPage = useCallback((params: string) => dispatch(setConnectedInstagramPage(params)), [dispatch])
  const dispatchGetUser = useCallback(() => dispatch(getCurrentUserInitiated()), [dispatch])

  const authorizationUrl: string | undefined = useSelector(getFacebookRedirect)
  const connectedFacebookPage: string | undefined = useSelector(getConnectedFacebookPage)
  const connectedInstagramPage: string | undefined = useSelector(getConnectedInstagramPage)
  const connectionChanged: boolean = useSelector(getConnectionChanged)
  const connectedUserPages = useSelector(getUserPages)
  const tokenChanged = useSelector(getTokenChanged)

  useEffect(() => {
    if (connectedFacebookPage && tokenChanged && !!connectedUserPages?.length) {
      const facebookParams: GetFacebookPageRequest = {
        networkPageId: connectedFacebookPage,
      }
      dispatchGetFacebookPage(facebookParams)
    }

    if (connectedInstagramPage && tokenChanged && !!connectedUserPages?.length) {
      const instagramParams: GetInstagramPageRequest = {
        networkPageId: connectedInstagramPage,
      }
      dispatchGetInstagramPage(instagramParams)
    }
  }, [connectedFacebookPage, connectedInstagramPage, tokenChanged, connectedUserPages])

  useEffect(() => {
    !!connectedUserPages && !!connectedUserPages.length && connectedUserPages.map(connectedPage => {
      connectedPage.networkType === NetworkType.Facebook && dispatchSetConnectedFacebookPage(connectedPage.networkPageId)
      connectedPage.networkType === NetworkType.Instagram && dispatchSetConnectedInstagramPage(connectedPage.networkPageId)
    })
  }, [connectedUserPages])

  useEffect(() => {
    connectionChanged && dispatchGetUser()
  }, [connectionChanged],
  )

  useEffect(() => {
    if (authorizationUrl) {
      window.location.replace(authorizationUrl)
    }
  }, [authorizationUrl],
  )

  return (
    <Container maxWidth='lg'>
      <Grid container sx={{ px: 2, pb: 12 }}>
        <Paper className={classes.paper}>
          <Grid container item spacing={2} xs={12}>
            <Grid item xs={12}>
              <UserWizardStepper setWizardCompleted={setWizardCompleted} />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Container>
  )
}
export default UserWizard
